import {fabric} from 'fabric';
import {AbstractShapeFactory} from './AbstractShapeFactory';
import {WBUtils} from '../util/WBUtils';

export class LineFactory extends AbstractShapeFactory {

  private stroke: number;

  constructor() {
    super();
    this.awType = 'line';
    this.parentButton = WBUtils.buttonBasic;
  }

  /**
     * Creates and returns a fabric line object at position (anchorX/anchorY) and sets
     * the attriubtes color, fill and stroke
     */
  public create(anchorX: number, anchorY: number, color: string, fill: string, stroke: number): any {
    this.stroke = stroke;
    this.shapeObject = new fabric.Line(
      [anchorX - stroke / 2, anchorY - stroke / 2,
        anchorX - stroke / 2, anchorY - stroke / 2], {
        left: anchorX - stroke / 2,
        top: anchorY - stroke / 2,
        stroke: color,
        strokeWidth: stroke,
        selectable: false,
        strokeLineJoin: 'round'
      });

    return this.shapeObject;
  }

  /**
     * modifies the line object expanding it to position (eventX/eventY).
     */
  public modify(anchorX: number, anchorY: number, eventX: number, eventY: number) {
    this.shapeObject.set({ x2: (eventX - this.stroke / 2), y2: (eventY - this.stroke / 2) });
  }

  /**
     * Executes the copy method of the AbstractShapeFactory
     */
  public copyAndDrop(id: number, awtype: string, callback: (clone) => void) {
    this.copy(id, awtype, callback);
  }

}
